import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { StateManager } from './shared/state-manager.class';
import { UnknownUser } from './user/unknown-user.model';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        RouterOutlet,
        RouterModule
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {

    public title = "frontend"

    private auth: Auth = inject(Auth);
    private router: Router = inject(Router);
    private stateManager: StateManager = inject(StateManager);
 
    public ngOnInit() {
        this.auth.onAuthStateChanged((user) => {
            if (user) {
                if (user?.emailVerified) {
                    // Verified User signed in
                } else {
                    // Unverified User is signed in
                    const userAccount = new UnknownUser();
                    if (user.email != null) {
                        userAccount.email = user.email;
                    }
                    this.stateManager.setUserAccount(userAccount);

                    this.router.navigate(['/pending-verification'])
                }
            } else {
                // User is not signed out
                this.router.navigate(['/login'])
            }
        });
    }
}
